<template>
  <v-dialog v-model="internalOpen" max-width="500px" persistent>
    <v-card>
      <v-card-text class="text-md-center" v-if="rawHtml" v-html="message"></v-card-text>
      <v-card-text class="text-md-center" v-else>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    // TODO refactor with slots using =\
    data () {
      return {
        internalOpen: false
      }
    },
    watch: {
      open () {
        this.internalOpen = this.open
      }
    },
    methods: {
      dialogClose () {
        this.$emit('closedialog')

        this.internalOpen = false
      }
    },
    props: {
      open: {
        type: Boolean,
        required: true,
        default: false
      },
      message: {
        type: String,
        required: true,
        default: ''
      },
      rawHtml: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppMainDialog.vue?4fb5cd92